import moment from 'moment';
import { getValueByPath } from '../../../../helpers/getValueByPath';

const sortOrder = (sortedInfo, key) => {
  const { columnKey, order } = sortedInfo || {};
  return columnKey === key && order;
};

const stableSort = (a, b, path, order, compare) => {
  const aVal = getValueByPath(a, path);
  const bVal = getValueByPath(b, path);
  const isAsc = order === 'ascend';

  if (!aVal && !bVal) return 0;
  if (!aVal) return isAsc ? 1 : -1;
  if (!bVal) return isAsc ? -1 : 1;

  return compare(isAsc ? aVal : bVal, isAsc ? bVal : aVal);
};

const sorters = {
  date: (path) => (order) => (a, b) =>
    stableSort(a, b, path, order, (a, b) => moment(a).diff(moment(b))),

  number: (path) => (order) => (a, b) =>
    stableSort(a, b, path, order, (a, b) => a - b),

  string: (path) => (order) => (a, b) =>
    stableSort(a, b, path, order, (a, b) => a.localeCompare(b)),

  boolean: (path) => (order) => (a, b) =>
    stableSort(a, b, path, order, (a, b) => Number(!!a) - Number(!!b)),
};

const filterItems = ({ filteredInfo, items, keyPathMap }) =>
  Object.entries(filteredInfo).reduce((acc, [key, values]) => {
    if (values) {
      return acc.filter((item) => {
        const itemVal = getValueByPath(item, keyPathMap[key]);
        return values.includes(itemVal);
      });
    }

    return acc;
  }, items);

const sortAndFilterData = ({ items, sortedInfo, filteredInfo, keyPathMap }) => {
  if (!items?.length) return [];

  const definedFilteredInfo = Object.entries(filteredInfo || {}).reduce(
    (acc, [key, value]) => {
      if (value?.length) {
        acc ? (acc[key] = value) : (acc = { [key]: value });
      }

      return acc;
    },
    null
  );

  if (!sortedInfo?.order && !definedFilteredInfo) return items;

  if (!sortedInfo?.order && definedFilteredInfo) {
    return filterItems({
      filteredInfo: definedFilteredInfo,
      items,
      keyPathMap,
    });
  }

  if (sortedInfo?.order && !definedFilteredInfo) {
    return items.slice().sort(sortedInfo.column.sorter(sortedInfo.order));
  }

  const filteredItems = filterItems({
    filteredInfo: definedFilteredInfo,
    items,
    keyPathMap,
  });

  return filteredItems.sort(sortedInfo.column.sorter(sortedInfo.order));
};

const createFilter = ({ shutdown, result, columnKey, dataIndex }) => {
  const value = getValueByPath(shutdown, dataIndex);

  if (value) {
    const resultValue = result[columnKey];
    const item = { text: value.name, value: value.id };

    if (!resultValue) {
      result[columnKey] = new Map([[value.id, item]]);
    } else if (!resultValue.has(value.id)) {
      resultValue.set(value.id, item);
    }
  }
};

export { sortOrder, sorters, sortAndFilterData, createFilter };
